import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
import CreateStaffSelector from "@cloudpivot/form/src/common/components/createStaffSelector.vue";
let DepartmentMultiSelectorDesign = class DepartmentMultiSelectorDesign extends Vue {
    render(h) {
        return h('create-staff-selector', { props: { opts: { disabled: true }
            } });
    }
};
tslib_1.__decorate([
    Prop()
], DepartmentMultiSelectorDesign.prototype, "control", void 0);
DepartmentMultiSelectorDesign = tslib_1.__decorate([
    Component({
        name: 'DepartmentMultiSelectorDesign',
        components: {
            CreateStaffSelector
        }
    })
], DepartmentMultiSelectorDesign);
export default DepartmentMultiSelectorDesign;
